export default "\n/* Stil för UI-element */\n"